function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.78 0A8.77 8.77 0 11.01 8.77 8.77 8.77 0 018.78 0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.96 4.68a1 1 0 00-1-1 1.16 1.16 0 00-1.19 1 1 1 0 001 1 1.15 1.15 0 001.19-1m-.9 6.63a.18.18 0 00-.19.15c-.62 1.49-1.06 1.53-1.21 1.53s-.36-.21-.17-.72l1.49-4.25a.86.86 0 00-.23-1.13 1.38 1.38 0 00-.66-.15 6.2 6.2 0 00-2.42.81.15.15 0 00-.07.23l.12.2c0 .07.1.08.22 0a6.77 6.77 0 01.74-.25c.3-.08.57 0 .43.37l-1.23 3.6a2.92 2.92 0 00-.17.86 1.26 1.26 0 001.36 1.28c1 0 1.71-.6 2.37-2.4 0-.12 0-.17-.1-.17h-.27z",
  fill: "#4d4d4d"
});

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 17.55 17.55"
  }, props), _ref, _ref2);
};

export default SvgInfo;